(function(){
  'use strict';

  /* ── Photos: embedded copies load instantly; CDN is the no-JS / error fallback ── */
  var FALL = {
    'hero-mother':'https://i.imgur.com/w3e0jYm.jpeg',
    'child-camp':'https://i.imgur.com/0FVVDp5.jpeg',
    'family-coast':'https://i.imgur.com/ToV4SaZ.jpeg',
    'children-meal':'https://i.imgur.com/AC5bpAI.jpeg',
    'scarf-held':'https://i.imgur.com/As7Hw6f.jpeg',
    'scarf-worn':'https://i.imgur.com/A5tg4qP.jpeg',
    'scarf-main':'https://i.imgur.com/bAwADCn.jpeg',
    'scarf-info':'https://i.imgur.com/wuD8r02.jpeg',
    'children-shelter':'https://i.imgur.com/MLy0mMF.jpeg'
  };
  if (window.__IMGS){
    document.querySelectorAll('img[data-img]').forEach(function(el){
      var k = el.getAttribute('data-img'), local = window.__IMGS[k];
      if (!local) return;
      el.addEventListener('error', function h(){
        el.removeEventListener('error', h);
        if (FALL[k] && el.src !== FALL[k]) el.src = FALL[k];
      });
      el.src = local;
    });
  }

  /* ── Mobile menu ── */
  var hamburger = document.getElementById('hamburger');
  var mobileMenu = document.getElementById('mobileMenu');
  var menuOpen = false;
  function closeMenu(){
    menuOpen = false;
    hamburger.classList.remove('active');
    hamburger.setAttribute('aria-expanded','false');
    mobileMenu.classList.remove('open');
    document.body.style.overflow = '';
  }
  function openMenu(){
    menuOpen = true;
    hamburger.classList.add('active');
    hamburger.setAttribute('aria-expanded','true');
    mobileMenu.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  hamburger.addEventListener('click', function(){ menuOpen ? closeMenu() : openMenu(); });
  mobileMenu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeMenu); });
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && menuOpen) closeMenu(); });

  /* ── Progress ribbon + nav shadow ── */
  var nav = document.getElementById('nav');
  var progress = document.getElementById('progressBar');
  function setChrome(){
    nav.classList.toggle('scrolled', window.scrollY > 8);
    var h = document.documentElement.scrollHeight - window.innerHeight;
    progress.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
  }

  /* ── Gallery ── */
  var mainImg = document.getElementById('mainImg');
  var thumbs = document.querySelectorAll('#thumbs button');
  thumbs.forEach(function(btn){
    btn.addEventListener('click', function(){
      thumbs.forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
      mainImg.style.opacity = '0';
      setTimeout(function(){ mainImg.src = (window.__IMGS && window.__IMGS[btn.dataset.img]) ? window.__IMGS[btn.dataset.img] : btn.dataset.src; mainImg.style.opacity = '1'; }, 180);
    });
  });

  /* ── Quantity → price + days of meals ── */
  var qty = 1, UNIT = 399;
  var cartSVG = ' <svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="2"><path d="M6 6h15l-1.5 9h-12z"/><circle cx="9.5" cy="20" r="1.5"/><circle cx="18" cy="20" r="1.5"/><path d="M6 6L5 3H2"/></svg>';
  var mealsLine = document.getElementById('mealsLine');
  window.changeQty = function(d){
    qty = Math.max(1, qty + d);
    document.getElementById('qtyVal').textContent = qty;
    document.getElementById('addToCart').innerHTML = 'Add to Cart — ₹' + (qty * UNIT).toLocaleString('en-IN') + cartSVG;
    var days = qty * 2;
    mealsLine.innerHTML = 'You\'ll fund <b>' + days + ' days</b> of meals' + (qty > 1 ? ' — ' + qty + ' children fed in 2 days.' : '.');
  };

  /* ── Add-to-cart feedback + toast (wire to your store /cart/add in production) ── */
  var addToCartBtn = document.getElementById('addToCart');
  var toast = document.getElementById('toast');
  var toastMsg = document.getElementById('toastMsg');
  var cartTimeout = null, toastTimeout = null;
  /* ── Shopify wiring: real cart when a product is picked in the theme editor ── */
  window.__AMAL_CART_COUNT = null;
  function shopifyAdd(q, goTo){
    addToCartBtn.innerHTML = 'Adding…';
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: window.__AMAL_VARIANT, quantity: q }] })
    }).then(function(res){
      if (!res.ok) throw new Error('Cart request failed');
      return res.json();
    }).then(function(){
      toastMsg.textContent = (q * 2) + ' days of meals funded. Somewhere tonight, a mother says shukran.';
      toast.classList.add('show');
      toastTimeout = setTimeout(function(){ toast.classList.remove('show'); }, 2400);
      window.location.href = goTo === 'checkout' ? '/checkout' : '/cart';
    }).catch(function(){
      addToCartBtn.innerHTML = 'Add to Cart — ₹' + (qty * UNIT).toLocaleString('en-IN') + cartSVG;
      toastMsg.textContent = 'Could not add to cart — please try again.';
      toast.classList.add('show');
      setTimeout(function(){ toast.classList.remove('show'); }, 3200);
    });
  }
  addToCartBtn.addEventListener('click', function(e){
    e.preventDefault();
    if (window.__AMAL_VARIANT){ shopifyAdd(qty, 'cart'); return; }
    if (cartTimeout) return;
    var oldHTML = addToCartBtn.innerHTML;
    addToCartBtn.innerHTML = '✓ &nbsp;Added — Shukran, habibi';
    addToCartBtn.style.background = 'var(--green-deep)';
    toastMsg.textContent = (qty * 2) + ' days of meals funded. Somewhere tonight, a mother says shukran.';
    toast.classList.add('show');
    toastTimeout = setTimeout(function(){ toast.classList.remove('show'); }, 3200);
    cartTimeout = setTimeout(function(){
      addToCartBtn.innerHTML = oldHTML;
      addToCartBtn.style.background = '';
      cartTimeout = null;
    }, 2400);
  });
  var buyNowBtn = document.getElementById('buyNow');
  if (buyNowBtn) buyNowBtn.addEventListener('click', function(e){
    if (window.__AMAL_VARIANT){ e.preventDefault(); shopifyAdd(qty, 'checkout'); return; }
    e.preventDefault();
    document.getElementById('shop').scrollIntoView({ behavior:'smooth' });
  });

  /* ── Delivery ETA (7–12 days from today) ── */
  (function(){
    var el = document.getElementById('etaDate');
    if (!el) return;
    var opts = { day:'numeric', month:'short' };
    el.textContent = new Date(Date.now()+7*864e5).toLocaleDateString('en-IN',opts) + ' – ' + new Date(Date.now()+12*864e5).toLocaleDateString('en-IN',opts);
  })();

  /* ── Scroll reveal ── */
  var rvEls = document.querySelectorAll('.rv');
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold:.08, rootMargin:'0px 0px -24px 0px' });
    rvEls.forEach(function(el){ io.observe(el); });
  } else {
    rvEls.forEach(function(el){ el.classList.add('in'); });
  }

  /* ── Animated counters (hero stats + impact %) ── */
  function countUp(el){
    var target = parseInt(el.dataset.count,10), start = null, dur = 1500;
    function step(ts){
      if (!start) start = ts;
      var p = Math.min((ts-start)/dur,1), e = 1-Math.pow(1-p,3), v = Math.round(target*e);
      el.innerHTML = el.classList.contains('pct') ? v + '<sup>%</sup>' : v;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  var counters = document.querySelectorAll('[data-count]');
  var impactBar = document.getElementById('impactBar');
  if ('IntersectionObserver' in window){
    var io2 = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){
          countUp(en.target);
          if (en.target.classList.contains('pct') && impactBar) impactBar.classList.add('in');
          io2.unobserve(en.target);
        }
      });
    }, { threshold:.4 });
    counters.forEach(function(el){ io2.observe(el); });
  } else {
    counters.forEach(function(el){ el.innerHTML = el.classList.contains('pct') ? el.dataset.count + '<sup>%</sup>' : el.dataset.count; });
    if (impactBar) impactBar.classList.add('in');
  }

  /* ── FAQ single-open ── */
  var qas = document.querySelectorAll('.qa');
  qas.forEach(function(qa){
    qa.addEventListener('toggle', function(){
      if (qa.open) qas.forEach(function(o){ if (o !== qa) o.open = false; });
    });
  });

  /* ── Sticky buy bar ── */
  var heroEl = document.getElementById('hero');
  var shopEl = document.getElementById('shop');
  var stickyBar = document.getElementById('stickyBuy');
  var ticking = false;
  function onScrollFrame(){
    setChrome();
    var pastHero = window.scrollY > heroEl.offsetHeight - 80;
    var r = shopEl.getBoundingClientRect();
    var inShop = r.top < window.innerHeight * .62 && r.bottom > window.innerHeight * .3;
    stickyBar.classList.toggle('show', pastHero && !inShop);
    ticking = false;
  }
  window.addEventListener('scroll', function(){
    if (!ticking){ requestAnimationFrame(onScrollFrame); ticking = true; }
  }, { passive:true });
  onScrollFrame();
})();
